import React from "react";

// Material UI
import { Button, Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";

// Styles
import { buttonStyles } from "Common/Styles";

const AddNewIcon = ({ onClick, tooltipInfo }) => {
  return (
    <Tooltip title={tooltipInfo} arrow>
      <Button
        size="large"
        aria-label={tooltipInfo}
        onClick={onClick}
        sx={{
          ...buttonStyles.greenActionButton,
          width: "fit-content",
          alignSelf: "center",
        }}
      >
        <Add sx={{ color: "white" }} />
      </Button>
    </Tooltip>
  );
};

export default AddNewIcon;
